import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioUnidadeMedida } from '../../sync/repositories/almoxarifado';
import { extrairMensagensErro } from '../../utils/errorUtils';

/** Modal de cadastro rápido de Unidade de Medida. */
export default function ModalCadastroUnidadeMedida({ isOpen, onClose, onSuccess }) {
  const [sigla, setSigla] = useState('');
  const [descricao, setDescricao] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSigla('');
      setDescricao('');
      setErros([]);
      setSalvando(false);
    }
  }, [isOpen]);

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!sigla.trim()) { setErros(['A sigla é obrigatória.']); return; }
    if (sigla.trim().length > 5) { setErros(['A sigla deve ter no máximo 5 caracteres.']); return; }
    if (!descricao.trim()) { setErros(['A descrição é obrigatória.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioUnidadeMedida.criar({ sigla: sigla.trim(), descricao: descricao.trim() });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Unidade de Medida">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Sigla * (máx. 5 caracteres)</label>
          <input
            type="text"
            value={sigla}
            onChange={(e) => setSigla(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: kg, L, un..."
            maxLength={5}
            autoFocus
            disabled={salvando}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Descrição *</label>
          <input
            type="text"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Quilograma, Litro, Unidade..."
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
